import React from 'react'
import Title from '../title'
import { Container, P, Button, A } from './styles'

const ContentBlock = ({ AdditionalComponent, ...props }) => (
  <Container {...props}>
    {props.titleText && <Title text={props.titleText} variant="h2" centered wrap />}
    {props.paragraphs.map((text, index) => <P key={index}>{text}</P>)}
    {props.buttonHref && props.buttonText && <Button to={props.buttonHref}>{props.buttonText}</Button>}
    {props.aHref && props.aText && <A href={props.aHref} target="_blank" rel="noopener noreferrer">{props.aText}</A>}
    {AdditionalComponent && <AdditionalComponent />}
  </Container>
)

ContentBlock.defaultProps = {
  paragraphs: []
}

export default ContentBlock
